import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Redirect } from 'react-router'
import Loader from '../../components/LoaderOverlay'

const Background = styled.div`
  width:100%;
  height:100%;
  background-color:white;
  position: relative;
  height: 100vh;
`

const Shell = styled.div`
  position: absolute;
  box-sizing:border-box;
  overflow:auto;
  width: 500px;
  padding:50px;
  border-radius: 6px;
  text-align:center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .error {
    color: red;
    margin-top: 20px;
  }

  img {
    width: 100px;
    margin-bottom:40px;
  }

  input {
    padding: 15px;
    border-radius:3px;
    width:100%;
    margin-bottom:15px;
    font-size: 12px;
    color: #4C4C4C;
    outline:none;
    border: 1px solid #D4D9E2;
    box-sizing:border-box;
  }

  h2 {
    font-size: 20px;
    color: #434C5F;
    font-weight:400;
    letter-spacing: 0.7px;
    line-height: 14px;
    align:left;
    margin-bottom:15px;
  }

  p {
    color: #596377;
    font-size:14px;
    line-height:20px;
    font-weight:100;
    margin-bottom:40px;
  }

  a {
    display:block;
    font-size:12px;
    margin-bottom:20px;

    &.reject {
      font-family: Roboto-Light;
      color: #C0C0C0;
      letter-spacing: 0.78px;
    }

  }
`

const Submit = styled.button`
  background: #FFFFFF;
  border: 1px solid #34A8F0;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.21);
  border-radius: 3px;
  text-transform:uppercase;
  color: #34A8F0;
  padding: 15px 0;
  text-decoration:none;
  width:100%;
  margin-top:15px;
  font-size:12px;
  cursor:pointer;
`

const ErrorMessage = styled.caption`
  color:red;
  display:block;
  margin-top:20px;
  font-size:12px;
  line-height:12px;
`

const SignInButton = styled(Link)`
  position:fixed;
  top:20px;
  right:20px;
  padding: 8px 22px;
  border: 1px solid #34A8F0;
  text-decoration:none;
  color: #34A8F0;
  border-radius:3px;
`

class SignUp extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loaderVisible: false,
      redirect: false,
      error: ''
    }
  }

  createAccount = () => {

    this.setState({loaderVisible: true});

    this.props.submit(this.state.name, this.state.email, this.state.password).then((subResponse) => {
      this.props.logIn(this.state.email, this.state.password).then((token) => {

        localStorage.setItem("token", token.data.signInUser);

        if(subResponse.data.createAccount.name) {
          this.setState({
            redirect: true
          })
        }
      })
    }).catch((error) => {
     console.log(error)
   })
  }

  inputToState = (e) => {

    if(e.target) {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  }

  errorMessage = () => {
    if (this.state.error) {
      return <ErrorMessage>{this.state.error}</ErrorMessage>
    }
  }

  render() {

    const { redirect } = this.state;
    const { loaderVisible } = this.state;

    if(redirect) {
      return <Redirect to="/setup/intercom"/>
    } else if (loaderVisible) {
      return <Loader />
    } else {
      return (
        <Background>
          <SignInButton to={'/'}>Sign In</SignInButton>
          <Shell>
            <h2>Sign Up</h2>
            <p> Answer a few quick questions and get quality churn prediction for Intercom</p>
            <input type="text" onChange={this.inputToState} name="name" placeholder="COMPANY NAME"/>
            <input type="email" onChange={this.inputToState} name="email" placeholder="EMAIL"/>
            <input type="password" onChange={this.inputToState} name="password" placeholder="PASSWORD" />
            {this.errorMessage()}
            <Submit onClick={this.createAccount} >Sign Up</Submit>
          </Shell>
        </Background>
      )
    }
  }
}

const CreateAcct = gql`
    mutation createAccount ($name: String!, $email: String!, $password: String!){
      createAccount(name: $name, email: $email, password: $password) {
        name
      }
    }
`;

const LogInUser = gql`
    mutation signInUser ($email: String!, $password: String!){
      signInUser(email: $email, password: $password)
    }
`;

const CreateAccount = compose(
  graphql(CreateAcct, {
    props: ({ mutate }) => ({
      submit: (name, email, password) => mutate({ variables: { name, email, password } })
    })
  }),
  graphql(LogInUser, {
    props: ({ mutate }) => ({
      logIn: (email, password) => mutate({ variables: { email, password } })
    })
  })
)(SignUp);

export default CreateAccount



// WEBPACK FOOTER //
// ./src/containers/signUp/index.js